import { NavLink } from "react-router-dom";

import { cn } from "@/lib/utils";

export type SettingsSectionTab = {
  to: string;
  label: string;
  end?: boolean;
};

interface SettingsSectionTabsProps {
  tabs: SettingsSectionTab[];
}

function tabPillClass(isActive: boolean) {
  return cn(
    // `!` (Tailwind !important) needed because NavLink renders <a>; the browser default
    // `a:visited { color: purple }` was outranking plain text-*. Matches the same pattern
    // used in NavUserDropdown (`!text-black`).
    "inline-flex h-6 cursor-pointer items-center justify-center gap-1 rounded-lg px-1 py-1 text-xs !text-[#71717A] transition-all duration-300",
    isActive && "bg-[#F4F4F5] px-2 !text-black",
  );
}

/** Matches dashboard FilterTab: thin vertical rule between options. */
function TabSeparator() {
  return <div className="mx-2 h-4 w-px shrink-0 self-center bg-gray-300" aria-hidden />;
}

export function SettingsSectionTabs({ tabs }: SettingsSectionTabsProps) {
  if (tabs.length === 0) {
    return null;
  }

  return (
    <div className="relative flex min-w-0 flex-row flex-wrap items-center text-xs" role="navigation" aria-label="Settings sections">
      <div className="flex min-w-0 flex-row overflow-x-auto pr-2" style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}>
        {tabs.map((tab, index) => (
          <div className="flex flex-row items-center" key={tab.to}>
            <NavLink to={tab.to} end={tab.end ?? true} className={({ isActive }) => tabPillClass(isActive)}>
              <span className="!font-medium whitespace-nowrap">{tab.label}</span>
            </NavLink>
            {index < tabs.length - 1 ? <TabSeparator /> : null}
          </div>
        ))}
      </div>
    </div>
  );
}
